/**
 * Login page
 */
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useOktaAuth } from '@okta/okta-react';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import { validateEmail } from '../../constants/utils'
import { Link as RouterLink } from "react-router-dom";
import Button from '../../components/Button';
import { ROUTES } from '../../constants/routes'
import AuthLayout from '../../components/AuthLayout/AuthLayout';
import { loginUser } from '../../modules/actions/authActions';

const loginValidations = {
  username: validateEmail,
  password: (pass) => /.{2,}/.test(pass) ? true : 'Enter minimum 2 characters',
};

function Login() {
  const [formData, setFormData] = useState({});
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const { loading, error } = useSelector((state) => state.auth)
  const dispatch = useDispatch();
  const { oktaAuth} = useOktaAuth();

  async function validateCredentials() {
    if ((loginValidations.username(formData.username) && loginValidations.password(formData.password))) {
      dispatch(loginUser(formData))
    }
  };

  async function fetchOktaLink() {
  try {
    oktaAuth.signInWithRedirect({originalUri: '/login/'})
  } catch (error) {

    console.error(error)
  }
}

  const handleInputChangeForUN = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value.toLowerCase(),
    }));
    (name && value) && setSubmitDisabled(false);
  };

  const handleInputChangeForPWD = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    (name && value) && setSubmitDisabled(false);
  };

  const handleOktaLogin = () => {
    fetchOktaLink()
  }

  return (
      <AuthLayout title={'Sign In'}>
        <Typography style={{ margin: '15px' }}>
          To access your account, please enter your registered email and password.
        </Typography>
        <FormControl fullWidth={true}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="username"
            autoComplete="email"
            autoFocus
            onChange={handleInputChangeForUN}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={handleInputChangeForPWD}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{margin: '24px 0 16px'}}
            onClick={validateCredentials}
            disabled={submitDisabled}
          >
          { loading && !error ? <CircularProgress size={24} color="secondary" /> : 'Sign in' }
          </Button>
          { error &&
            <Typography variant="body2" textAlign="center" sx={{margin: '16px 0'}} color="error">
              <>Invalid email or password.</>
            </Typography>
          }
        <Grid justifyContent="space-between" container>
          <Grid item>
            <Link variant="body2" component="button" onClick={handleOktaLogin}>
            Login via Okta
            </Link>
          </Grid>
          {/* Hidden Forgot password until further confirmation */}
          <Grid style={{'display': 'none'}} item>{<Link component={RouterLink} to={ROUTES.forgotPassword} variant="body2">Forgot password?</Link>}</Grid>
        </Grid>
        </FormControl>
      </AuthLayout>
  )
}

export default Login
  